import { updateById, checkId, getById, getByIds, getBySlug, checkIds, put, updateModerationInfo, updateVerifiedAt, deleteAll } from './moviesMethods';

export const supabaseMoviesInit = (supabase) => { return {
  getById: getById.bind(this, supabase),
  getByIds: getByIds.bind(this, supabase),
  getBySlug: getBySlug.bind(this, supabase),
  checkId: checkId.bind(this, supabase),
  checkIds: checkIds.bind(this, supabase),
  updateById: updateById.bind(this, supabase),
  put: put.bind(this, supabase),
  updateModerationInfo: updateModerationInfo.bind(this, supabase),
  updateVerifiedAt: updateVerifiedAt.bind(this, supabase),
  deleteAll: deleteAll.bind(this, supabase),
}}